import { Box } from '@mui/material';
import { appConfig } from '@/config/appConfig';
import { useConfiguration } from '@/configuration';
import { layout } from '@/constants/layout';

interface BrandLogoProps {
  onClick?: () => void;
  variant?: 'full' | 'icon';
}

export function BrandLogo({ onClick, variant = 'full' }: BrandLogoProps) {
  const { settings } = useConfiguration();
  const isIcon = variant === 'icon';
  const logoPath = settings?.branding.portalLogoUrl ?? appConfig.logoPath;
  const logoAlt = settings?.general.portalName ?? appConfig.logoAlt;

  return (
    <Box
      component={onClick ? 'button' : 'a'}
      href={onClick ? undefined : '/'}
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      aria-label={logoAlt}
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        lineHeight: 0,
        border: 0,
        p: 0,
        bgcolor: 'transparent',
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      <Box
        component="img"
        src={logoPath}
        alt={logoAlt}
        sx={
          isIcon
            ? {
                display: 'block',
                width: layout.logoIconSize,
                height: layout.logoIconSize,
                objectFit: 'contain',
              }
            : {
                display: 'block',
                width: layout.logoWidth,
                height: 'auto',
                maxHeight: layout.logoMaxHeight,
              }
        }
      />
    </Box>
  );
}
